import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "loading-dots__dot" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loading-dots__dot" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-dots__dot" }, null, -1)
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loading-dots", { ['loading-dots_' + _ctx.type]: true }])
  }, _hoisted_4, 2))
}